import { Navigate, Outlet, useLocation } from "react-router-dom";
import isAuthenticated from "../../services/authService";

const RequireAuth = () => {
    const auth = isAuthenticated();
    const location = useLocation();

    return auth ? (
        <Outlet />
    ) : (
        <Navigate to="/connexion" state={{ from: location }} replace />
    );
};

export default RequireAuth;
